export const apiUrl =
  process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_API_HOST || '';
